<template>
  <v-layout row wrap>
    <v-flex xs12 sm7>
      <v-card height="100%" class="pa-3 primary" v-if="noActivated">
        <h1 class="mb-4 ml-2 headline white--text">
          {{ $t('firstTeletag.pendingRequestLetter.title') }}
        </h1>
        <div class="white--text subheading px-2">
          {{ $t('firstTeletag.pendingRequestLetter.subtitle') }}
        </div>
        <div class="white--text subheading px-2">
          {{ $t('firstTeletag.pendingRequestLetter.text.1') }}
        </div>
        <v-btn
          round
          color="primary--text"
          class="white initialize"
          :to="{ path: $t('urlPrescriptor') }"
        >
          {{ $t('teletag.getTeletag.button.shop') }}</v-btn
        >
        <span class="white--text subheading" v-if="showRequestLetterButton"
          >o</span
        >
        <v-btn
          round
          v-if="showRequestLetterButton"
          color="primary--text"
          class="white initialize"
          @click="isShowingRequestLetterForm = true"
        >
          {{ $t('teletag.getTeletag.button.letter') }}</v-btn
        >
        <br /><br />
        <div class="white--text subheading px-2">
          {{ $t('firstTeletag.pendingRequestLetter.text.2') }}
        </div>
        <v-btn
          round
          color="primary--text"
          class="white initialize"
          @click="
            isShowingTeletagActivateBottomSheet = !isShowingTeletagActivateBottomSheet
          "
        >
          {{ $t('teletag.button.button.activate.teletag') }}</v-btn
        >
      </v-card>

      <v-card height="100%" class="pa-3 primary" v-else-if="sentLetter">
        <h1
          class="mb-4 ml-2 headline white--text"
          v-html="$t('firstTeletag.requestedLetter.title')"
        ></h1>

        <div
          class="white--text subheading px-2"
          v-html="$t('firstTeletag.requestedLetter.subtitle')"
        ></div>

        <v-btn
          round
          color="primary--text"
          class="white initialize mb-4"
          @click="
            isShowingTeletagActivateBottomSheet = !isShowingTeletagActivateBottomSheet
          "
        >
          {{ $t('teletag.button.button.activate.teletag') }}</v-btn
        >

        <advice color="white" textColor="white">
          <p v-html="$t('firstTeletag.requestedLetter.advice')"></p>
          <v-btn
            round
            color="primary--text"
            class="white initialize mb-4"
            small
            target="_blank"
            :href="`mailto:${contactEmail}`"
          >
            {{ $t('firstTeletag.requestedLetter.contact') }}</v-btn
          >
        </advice>

        <div
          class="white--text caption px-2 mt-4"
          v-html="$t('firstTeletag.requestedLetter.letter')"
        ></div>

        <v-card class="mx-2 pa-2 mt-1">
          <pre>{{ letter }}</pre>
        </v-card>
      </v-card>
    </v-flex>

    <v-flex xs12 sm5>
      <v-card height="100%" class="pa-3">
        <h4
          class="mt-3 caption grey--text text--darken-1"
          v-html="$t('firstTeletag.pendingRequestLetter.tutorial.title')"
        ></h4>
        <v-expansion-panel class="mt-3">
          <v-expansion-panel-content>
            <div
              slot="header"
              class="body-1 font-weight-regular"
              v-html="$t('firstTeletag.pendingRequestLetter.tutorial.1.title')"
            ></div>
            <v-card class="px-3 pb-2">
              <v-card-text
                class="pt-0 caption font-weight-light"
                v-html="$t('firstTeletag.pendingRequestLetter.tutorial.1.text')"
              >
              </v-card-text>
              <v-card-text class="pt-0">
                <img src="/image/teletag-inside-car.png" />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div
              slot="header"
              class="body-1 font-weight-regular"
              v-html="$t('firstTeletag.pendingRequestLetter.tutorial.2.title')"
            ></div>
            <v-card class="px-3 pb-2">
              <v-card-text
                class="pt-0 caption font-weight-light"
                v-html="$t('firstTeletag.pendingRequestLetter.tutorial.2.text')"
              >
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div
              slot="header"
              class="body-1 font-weight-regular"
              v-html="$t('firstTeletag.pendingRequestLetter.tutorial.3.title')"
            ></div>
            <v-card class="px-3 pb-2">
              <v-card-text
                class="pt-0 caption font-weight-light"
                v-html="$t('firstTeletag.pendingRequestLetter.tutorial.3.text')"
              >
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div
              slot="header"
              class="body-1 font-weight-regular"
              v-html="$t('firstTeletag.pendingRequestLetter.tutorial.4.title')"
            ></div>
            <v-card class="px-3 pb-2">
              <v-card-text
                class="pt-0 caption font-weight-light"
                v-html="
                  $t('firstTeletag.pendingRequestLetter.tutorial.4.text', {
                    price: teletagPrice
                  })
                "
              >
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <activate-teletag
          v-if="isShowingTeletagActivateBottomSheet"
          @on-success="pending"
          @on-close="closeTeletagActivateBottomSheet"
        ></activate-teletag>

        <request-letter-form
          v-if="isShowingRequestLetterForm"
          @on-success="refreshContent"
          @on-close="closeRequestLetterForm"
        ></request-letter-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Advice from '@/components/commons/Advice';
import RequestLetterForm from '@/components/private/tag/RequestLetterForm';
import ActivateTeletag from '@/components/private/tag/ActivateTeletag';
import userService from '@/services/userService';
import manageErrorService from '@/services/manageErrorService';
import letterService from '@/services/letterService';
import sessionService from '@/services/sessionService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import store from '@/store';
import utilService from '@/services/utilService';

export default {
  name: 'FirstTeletag',
  components: {
    [Advice.name]: Advice,
    [RequestLetterForm.name]: RequestLetterForm,
    [ActivateTeletag.name]: ActivateTeletag
  },
  computed: {
    sentLetter() {
      return userService.sentLetter() && this.letter !== null;
    },
    noActivated() {
      return userService.noActivated() || this.letter === null;
    },
    teletagPrice() {
      let price = store.state.countrySelected.prices.teletag;
      return this.$options.filters.addCurrencySymbol(price);
    },
    contactEmail() {
      return store.state.countrySelected.contact.email;
    }
  },
  data() {
    return {
      isShowingTeletagActivateBottomSheet: false,
      isShowingRequestLetterForm: false,
      letter: '',
      showRequestLetterButton: !utilService.isChile()
    };
  },
  created() {
    this.loadLastLetter();
  },
  mounted() {
    this.$nextTick(() => {
      EventBus.$emit(keys.eventShowDrawer);
      store.commit('CHANGE_TITLE_SECTION', { text: '' });
    });
  },
  methods: {
    async loadLastLetter() {
      let results = await letterService.getLast();

      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.letter = results.data;
    },
    closeTeletagActivateBottomSheet() {
      this.isShowingTeletagActivateBottomSheet = false;
    },
    closeRequestLetterForm() {
      this.isShowingRequestLetterForm = false;
    },
    async refreshContent() {
      await sessionService.check(true);
      this.loadLastLetter();
    },
    async pending() {
      await sessionService.check(true);
      this.$emit('on-activated-first-tag', {});
      this.$router.push({ path: this.$i18n.t('urlUser') });
    }
  }
};
</script>
